import { FormControl } from '@angular/forms';

import { isEmpty } from '@recruitee/utils';

const DOMAIN_PATTERN =
  /^(?!:\/\/)([a-zA-Z0-9-]+\.){0,5}[\-]?[a-zA-Z0-9-][a-zA-Z0-9-]+\.[a-zA-Z]{2,64}?$/;

export function domainValidator(
  control: FormControl<string | null>,
): { domainPattern: boolean } | null {
  return isEmpty(control.value) || DOMAIN_PATTERN.test(control.value)
    ? null
    : { domainPattern: true };
}
